<template>
	<div>
		<v-row>
			<v-col class="py-1">
				<v-data-table
					v-if="hasItens"
					:headers="colunas"
					:items="dataSource"
					:server-items-length="totalItens"
					item-key="id"
					:options="paginacaoInterna"
					no-data-text="Não há atas cadastradas"
					hide-default-footer
				>
					<template #item.isBloqueado="{ item }">
						<span>
							{{ item.isBloqueado | situacaoBloqueioItemAtaFilter }}
						</span>
					</template>

					<template #item.dataCadastro="{ item }">
						<span>
							{{ item.dataCadastro | formatDataHourMinuteFilter }}
						</span>
					</template>
				</v-data-table>
				<paginacao-tabela
					v-if="hasItens"
					:total-paginas="totalPaginas"
					:total-itens="totalItens"
					:page.sync="paginacaoInterna.page"
					:rows-per-page.sync="paginacaoInterna.rowsPerPage"
					@resetar-page="resetarPage"
					@paginar="setPaginacaoHistorico"
					class="py-1"
				>
					></paginacao-tabela
				>
				<template-listagem-vazia :textos="textos" :total-itens="totalItens" class="py-1"
					>></template-listagem-vazia
				>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'historico-bloquear',
	props: {
		itemSelecionado: {
			type: Object,
			default() {
				return {}
			},
		},
	},
	data() {
		return {
			dataSource: [],
			colunas: [
				new TabelaColunaUtils('Situação', 'isBloqueado', '15%'),
				new TabelaColunaUtils('Usuário', 'usuario.nome', '25%'),
				new TabelaColunaUtils('Data/Hora', 'dataCadastro', '20%'),
				new TabelaColunaUtils('Motivo', 'justificativa', '30%'),
			],
			paginacaoInterna: PaginacaoListagem(['id'], 5, 'DESC'),
			totalPaginas: 0,
			totalItens: 0,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
	},
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	async mounted() {
		this.resetarPage()
		await this.carregarHistoricos()
	},
	methods: {
		async carregarHistoricos() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.BLOQUEIO.HISTORICO.BUSCAR_HISTORICOS,
				this.itemSelecionado.id,
			)
			this.dataSource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.carregando = false
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ITEM_ATA.BLOQUEIO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.BLOQUEIO.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.carregarHistoricos()
		},
	},
}
</script>
